let show = true;
export function showCheckboxes() {
  let checkboxes = document.getElementById('check-boxes');
  if (show) {
    checkboxes.style.display = 'block';
    show = false;
  } else {
    checkboxes.style.display = 'none';
    show = true;
  }
}
